module.exports = {
  API_LOCATION: 'https://api.console.offthecouch.io/',
  WAIVER_URL: 'https://offthecouch.io/checkin/',
  BOOKING_URL: 'https://offthecouch.io/book/',
  REQUEST_URL: 'https://offthecouch.io/request/',
  LEADERBOARD_URL: 'https://offthecouch.io/leaderboard/',
  CDN_URL: 'https://cdn.offthecouch.io/',
  // Amazon Location API key otc-console-maps (OTC-2926): map tiles, address
  // autocomplete and geocode only, limited to the console and localhost:8080
  // referrers. Public by design.
  MAPS_API_KEY: 'v1.public.eyJqdGkiOiI3MjY0Y2M0Mi1iOGY5LTRhYTEtODdlNC1iZjU2NWI2MWQ5OGEifURGJC0PQ8C2R-butdAGhuwQvcxfaYDZyfymxE9RsN9aNG1dzUeLk9XwKfSvsuVHEsGUbj1p_2NENxgTh_iQ31NgHthctJ_qZj3W-Ez62Yt0uCQ9OuPCbcIHV5escNXqoprv4SGgvMMH7X045BUGKwwb43yE-2W5j8h9T8Eg6zxNLW4S6P-3ADBPFzabIDluEctFU9z4SVQZ0zLsXE1QpS7qZzlMkcraAw5-nVpO73DeDMnN8LbKakPjAGiilbih_RWaYiThXMssJiDYsYZVyA95DaUFNVDqT9Zah5jlE3NWXIyst7ifvHUkdTkljrpwFgPvS_ULxp7hFf-15wyBBBo.ZWU0ZWIzMTktMWRhNi00Mzg0LTllMzYtNzlmMDU3MjRmYTkx',
  MAPS_STYLE_URL: 'https://maps.geo.us-east-1.amazonaws.com/v2/styles/Standard/descriptor',
  MAPS_PLACES_URL: 'https://places.geo.us-east-1.amazonaws.com/v2',
  // Static URL for the OTC POS Android APK. Backed by the otc-pos-app S3
  // bucket via the apps.offthecouch.io CloudFront distribution (OAC, no
  // direct S3 access). Overwrite the object on each release; bucket
  // versioning preserves prior copies for rollback. Versioning manifest
  // + in-app update checks are explicit follow-ups.
  POS_APP_DOWNLOAD_URL: 'https://apps.offthecouch.io/otc-pos.apk',
  // The Stripe Reader S710 build (s710 product flavor, Stripe-only, no Square).
  // A venue downloads this to upload into their own Stripe Apps on Devices
  // portal. Host app-s710-release.apk at this path alongside otc-pos.apk.
  POS_APP_S710_DOWNLOAD_URL: 'https://apps.offthecouch.io/otc-pos-s710.apk',
}
